import { CallState, AgentState, UnavailableCode } from '../../types';

export interface CallContactEvent {
  contactId?: string;
  masterId?: string;
  status?: string;
  ani?: string;
  dnis?: string;
  toAddress?: string;
  skill?: string;
  skillId?: string;
  isInbound?: boolean;
  startTime?: Date | string;
  label?: string;
  isRequireManualAccept?: boolean;
  finalState?: boolean | string;
  FinalState?: boolean | string;
  allowDispositions?: boolean | string;
  AllowDispositions?: boolean | string;
  [key: string]: unknown;
}

export interface CXoneEventsState {
  callState: CallState;
  agentState: AgentState;
  unavailableCodes: UnavailableCode[];
  isRinging: boolean;
  isMuted: boolean;
  isRecording: boolean;
  agentLegId: string | null;
  agentLegStatus: string | null;
  isAgentLegActive: boolean;
  isWebRtcConnected: boolean;
  callError: string | null;
  acwTimeout: number | null;
  isInAcw: boolean;
}

export interface UseCXoneEventsReturn extends CXoneEventsState {
  acceptCall: () => void;
  rejectCall: () => void;
  setAgentState: (state: string, reasonCode?: string) => Promise<void>;
  refreshConferenceParties: () => Promise<void>;
}

export const initialCallState: CallState = {
  contactId: null,
  status: 'idle',
  direction: null,
  callerNumber: null,
  callerName: null,
  skillName: null,
  skillId: null,
  startTime: null,
  dnis: null,
  isMuted: false,
  isHeld: false,
  isConference: false,
  conferenceParties: [],
  isAutoAccept: false,
  requireDisposition: false,
};

export const initialAgentState: AgentState = {
  state: 'Unknown',
  reason: null,
  reasonCode: null,
  stateStartTime: null,
};
